<template>
  <div class="schedule-components">
    <div class="schedule">
      <div class="jumbotron">
        <img src="../assets/img/schedule/jumbotron.jpg" alt="" class="over_display">
        <img src="../assets/img/schedule/jumbotron_under.jpg" alt="" class="under_display">
      </div>
      <div class="catch-wrapper">
        <img src="../assets/img/schedule/catch.png" alt="社歴やライフステージが変わると、1日の過ごし方も変わる。sanwaが目指しているのは、「長い目で働ける会社」です。" width="450px">
      </div>
      <div class="main-contents-wrapper">
        <p class="main-contents-title">
          - 1日のスケジュール -
        </p>
        <div class="tab-wrapper">
          <div class="button" @click="openTabContents(1)" :class="{'active': openTab == 1}">
            <div class="button-inner">
              <i>入社1年目</i>の農産担当<br class="over_display">
              早番の1日をご紹介します。
            </div>
          </div>
          <div class="button" @click="openTabContents(2)" :class="{'active': openTab == 2}">
            <div class="button-inner">
              入社4年目のお客様係。<br class="over_display">
              <i>働きながら子育て</i>しています。
            </div>
          </div>
          <div class="button" @click="openTabContents(3)" :class="{'active': openTab == 3}">
            <div class="button-inner">
              入社23年目。<i>畜産部の<br class="over_display">
              バイヤー</i>を務めています。
            </div>
          </div>
        </div>
        <div class="change-contents">
          <div v-if="openTab == 1">
            <div class="photo">
              <img src="../assets/img/schedule/photo01.jpg" alt="">
            </div>
            <div class="timeset">
              <div class="time">7:55</div>
              <Fukidashi title="出勤〜開店準備" message="野菜や果物の売場への品出し。<br>仕入れる予定だった商品が揃わない場合、<br>別の商品で売場を埋めます。<br>また、商品の品質管理（鮮度チェック）も行います。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">10:00</div>
              <Fukidashi title="売場管理" message="その日の売れ行きに応じた商品の品出し、<br>品質管理、売場の手直しなど。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">11:30</div>
              <Fukidashi title="発注" message="翌日、翌々日に売場で陳列する<br>果物の発注を行います。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">12:00</div>
              <Fukidashi title="昼休み" message="同期や先輩社員、<br>パートさんと会話して過ごします。<br>お昼はsanwaのお弁当を食べています。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">13:00</div>
              <Fukidashi title="加工・品出し" message="袋詰めした野菜などを売場に出します。<br>空いた時間で、商品の知識を学ぶための<br class='under_display'>試食も。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">15:00</div>
              <Fukidashi title="売場管理" message="品質管理、売場の清掃、<br>冷蔵ケースの温度確認、<br class='under_display'>売場の手直しなど。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">16:00</div>
              <Fukidashi title="締めの売場管理" message="自分が退勤する前に、<br>遅番の人のために売場を整えておきます。" :isLeft="false" />
            </div>
            <div class="timeset last">
              <div class="time">17:10</div>
              <Fukidashi title="退勤" message="平日に早上がりのときは、<br>よくスポーツ観戦や映画に行きますね。<br>先輩や地元の友達と<br>飲みに行くことも多いです。" :isLeft="true" />
            </div>
            <div class="last-fukidashi">
              <div class="last-fukidashi-inner">
                <p class="title">研修がある日の場合</p>
                <p class="message">本部で8：00〜17：00までしっかりと<br>
                  研修を受けて、スキルアップを図っています。
                </p>
              </div>
            </div>
          </div>

          <div v-else-if="openTab == 2">
            <div class="photo">
              <img src="../assets/img/schedule/photo02.jpg" alt="">
            </div>
            <div class="timeset">
              <div class="time">8:30</div>
              <Fukidashi title="保育園へ" message="毎朝、子どもを連れて行きます。<br>自宅近くの店舗で勤務しているので、<br>送り迎えがしやすいです。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">10:00</div>
              <Fukidashi title="出勤〜デスクワーク" message="社内の情報共有システムの確認や、<br>前日に自分が不在だった時間帯に<br>レジで行われたことの報告などを<br class='under_display'>入力します。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">10:30</div>
              <Fukidashi title="レジ" message="自分がマネジメントするパートさんを<br>ヘルプする形で、レジに入ります。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">12:00</div>
              <Fukidashi title="デスクワーク" message="社内システムの確認など。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">13:00</div>
              <Fukidashi title="昼休み" message="だいたいパートさんと世間話を<br class='under_display'>しています。<br>お昼はゆっくり休みたいので、<br>sanwaのお弁当やパンにしています。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">14:00</div>
              <Fukidashi title="シフト作成" message="前の週や前月の勤務状況などを<br class='under_display'>確認しながら、<br>パートさんの勤務表を作成。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">16:00</div>
              <Fukidashi title="レジ" message="退勤前にもう一度、<br>お客様と直接接する時間をつくります。" :isLeft="false" />
            </div>
            <div class="timeset last">
              <div class="time">17:00</div>
              <Fukidashi title="退勤" message="子どもを保育園にお迎えに行って、<br>夕飯の支度をする、<br class='under_display'>というのが1日のルーティン。<br>家事と仕事が両立できることは<br>sanwaの大きな特徴です。" :isLeft="true" />
            </div>
            <div class="last-fukidashi">
              <div class="last-fukidashi-inner">
                <p class="title">時短勤務について</p>
                <p class="message">私は、10:00〜17:00の時短勤務で働いています。<br>
                  子どもが急に熱を出した日は、<br>
                  店長と相談して早退することもあります。
                </p>
              </div>
            </div>
          </div>

          <div v-else-if="openTab == 3">
            <div class="photo">
              <img src="../assets/img/schedule/photo03.jpg" alt="">
            </div>
            <div class="timeset">
              <div class="time">7:30</div>
              <Fukidashi title="家を出る" message="子どもが小学校へ行く時間に合わせて、<br>いっしょに出掛けます。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">8:00</div>
              <Fukidashi title="臨店（りんてん）" message="各店舗を巡廻します。<br>畜産部の売場でチーフと会話。<br>店舗の数字や効果的な売場レイアウトが<br>できているか確認します。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">11:00</div>
              <Fukidashi title="デスクワーク" message="本部へ出社。前日の売上数字の検証、<br>販促会議の資料作成などを行います。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">12:00</div>
              <Fukidashi title="昼休み" message="本部の食堂で昼食。週2日程度は外食して、<br>トレンドのメニューを研究します。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">13:00</div>
              <Fukidashi title="広告販促会議" message="販売戦略の会議。<br class='under_display'>各部門のバイヤーが集まり、<br>売り出したい商品の価格を決めます。<br>その際、他店より安く販売するために、<br>広告配信はギリギリまで待ちます。" :isLeft="false" />
            </div>
            <div class="timeset">
              <div class="time">16:00</div>
              <Fukidashi title="デスクワーク" message="地ブランド牛や豚などの調査。<br>当日の販売状況確認、会議書類の作成。" :isLeft="true" />
            </div>
            <div class="timeset">
              <div class="time">18:00</div>
              <Fukidashi title="バイヤーミーティング 部長会議" message="sanwaだけの買い物体験を<br class='under_display'>お客様に提供するため、<br>日々の会議を通じた<br class='under_display'>細かな情報共有は不可欠です。" :isLeft="false" />
            </div>
            <div class="timeset last">
              <div class="time">19:10</div>
              <Fukidashi title="退勤" message="本部での仕事を終えた後は、<br>近隣で同期が店長を務める店舗に赴いて、<br class='under_display'>雑談など。<br>帰宅して妻と晩酌。<br class='under_display'>子どもが起きている日は、<br>テレビゲームで対戦しています。" :isLeft="true" />
            </div>
            <div class="last-fukidashi">
              <div class="last-fukidashi-inner">
                <p class="title">出張がある日の場合</p>
                <p class="message">電車や車で、ウインナーやハムなどの<br class='under_display'>メーカー本社へ。<br>担当者のプレゼンを受け、<br class='under_display'>試食して買い付けを決めます。<br>出張先から帰社せずに直帰することもあります。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fukidashi from '@/components/schedule/Fukidashi.vue'
export default {
  name: 'Schedule',
  components: {
    Fukidashi
  },
  data() {
    return {
      openTab: 1,
      intersectionObserver: null,
    }
  },
  methods: {
    openTabContents(number) {
      this.openTab = number;
      let targets = Array.from(document.querySelectorAll('.fukidashi-components'));
      targets.forEach((element)=> {
        element.classList.remove("is-show");
      })
      this.startIntersectionObserver(targets);
    },
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [0,0.2,0.4,0.6,0.8,1.0],
        threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    let targets = Array.from(document.querySelectorAll('.fukidashi-components'));
    this.startIntersectionObserver(targets);
  },
  destroyed () {
    this.intersectionObserver.disconnect(); // すべての target に対し，監視をやめる
  }
}
</script>
<style scoped lang="scss">
.schedule {
  padding-bottom: 300px;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
  img {
    vertical-align: middle;
  }
}
.catch-wrapper {
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  margin-top: -100px;
  text-align: right;
  @media print, screen and (max-width: 900px) {
    width: 90%;
    margin-top: -10px;
  }
}
.main-contents-wrapper {
  max-width: 900px;
  margin: 0 auto;
  margin-top: 100px;
  width: 100%;
  @media print, screen and (max-width: 900px) {
    width: 90%;
  }
}
.main-contents-title {
  color: #e51c57;
  text-align: center;
  font-size: 24px;
  @media print, screen and (max-width: 900px) {
    font-size: 18px;
  }
}
.tab-wrapper {
  display: flex;
  max-width: 1120px;
  width: 100%;
}
.button {
  max-width: 360px;
  width: 100%;
  border: 1px solid #000;
  display: flex;
  justify-content: center;
  color: #e51c57;
  font-size: 16px;
  padding: 10px 10px 30px 10px;
  position: relative;
  @media print, screen and (max-width: 900px) {
    font-size: 13px;
    line-height: 2em;
  }
  &:after {
    content: url('../assets/img/schedule/tab.svg');
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    bottom: 10px;
  }
  cursor: pointer;
  &.active {
    border-bottom: 0;
    &:after {
      content: url('../assets/img/schedule/tab_active.svg');
    }
  }
  i {
    font-style: normal;
    background: linear-gradient(transparent 40%, #ffce48 40%);
  }
}
.button + .button {
  border-left: 0;
}
.change-contents {
  margin-top: 100px;
  position: relative;
  .photo {
    max-width: 480px;
    margin: 0 auto;
    &:after {
      content: "";
      height: 60px;
      width: 7px;
      background-color: #ffce48;
      display: block;
      position: relative;
      margin-top: -30px;
      @media print, screen and (min-width: 901px) {
        left: 50%;
        transform: translateX(-50%);
      }
      @media print, screen and (max-width: 900px) {
        transform: translateX(38px);
      }
    }
    img {
      border: 8px solid #ffce48;
      vertical-align: middle;
    }
  }
  .timeset {
    position: relative;
    &:after {
      content: "";
      width: 7px;
      background-color: #ffce48;
      display: block;
      position: relative;
      @media print, screen and (min-width: 901px) {
        left: 50%;
        transform: translateX(-50%);
        height: 30px;
      }
      @media print, screen and (max-width: 900px) {
        transform: translateX(38px);
        height: 100px;
      }
    }
    &.last {
      &:after {
        content: "";
        height: 100px;
        position: absolute;
      }
      &:before {
        content: url('../assets/img/schedule/arrow_down.svg');
        width: 57px;
        display: block;
        bottom: -120px;
        position: absolute;
        @media print, screen and (min-width: 901px) {
          left: 50%;
          transform: translateX(-50%);
        }
        @media print, screen and (max-width: 900px) {
          transform: translateX(13px);
        }
      }
    }
  }
  .time {
    position: relative;
    width: 70px;
    height: 70px;
    background-color: #e51c57;
    color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 8px solid #fff;
    font-family: "Pathway Gothic One", sans-serif;
    letter-spacing: 0.1em;
    @media print, screen and (min-width: 901px) {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.last-fukidashi {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 180px;
  background-color: #95b8c2;
  padding: 20px 30px;
  display: inline-block;
  border-radius: 10px;
  &:before {
    content: "";
    width: 0;
    height: 0;
    border: 20px solid transparent;
    border-bottom: 40px solid #95b8c2;
    display: block;
    position: absolute;
    top: -60px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .title {
    font-size: 17px;
    line-height: 2em;
    color: #fff;
    margin: 0;
  }
  .message {
    font-size: 12px;
    line-height: 2em;
    margin-top: 0;
  }
}
</style>
